var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!!_vm.value)?_c('div',{staticClass:"table_label",class:{ primary: _vm.primary }},[_c('span',{style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.text))]),_c('span',{style:(_vm.valueStyle)},[_vm._v(_vm._s(_vm.value))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }